module.exports = __webpack_public_path__ + "img/main-image.a7a374df.png";